<template>
  <div class="dealings-balance-view2-multi-currency">
    <div class="section operations" style="margin-bottom:2px;">
      <el-form inline style="margin-bottom:-12px;">
        <!--科目-->
        <el-form-item :label="$t('CargoMsg.Cargo_AccountTitle')">
          <el-select ref="accountTitleRef" v-model="form.accountTitle" style="width: 300px;" :filterable="true" :clearable="true" no="1">
            <el-option
              v-for="(item,index) in currentAccountTitleCollection"
              :key="index"
              :label="accountTitleLabelFun(item)"
              :value="item.uuid"
            />
          </el-select>
        </el-form-item>
        <!--业务员-->
        <el-form-item :label="$t('CargoMsg.Cargo_Salesman')">
          <cargo-advance-select
            :callback-params="{key:'sales'}"
            :default-value="form.sales"
            :select-type="selectTypeNames.basic_data_User"
            callback-method-type="value"
            filterable
            style="width: 140px;"
            no="2"
            @parentCallBack="selectChangeHandler"
          />
        </el-form-item>
        <!--客户-->
        <el-form-item :label="$t('CargoMsg.Cargo_Customer')">
          <cargo-advance-select
            :callback-params="{key:'customer'}"
            :default-value="form.customer"
            :select-type="selectTypeNames.basic_data_Company"
            callback-method-type="value"
            filterable
            style="width: 300px;"
            no="3"
            @parentCallBack="selectChangeHandler"
          />
        </el-form-item>
        <!--业务单号-->
        <el-form-item :label="$t('CargoMsg.Cargo_BusinessDocNo')">
          <el-input v-model="form.projectNumber" style="width: 140px;" no="4" />
        </el-form-item>
        <br>
        <!--部门-->
        <el-form-item :label="$t('CargoMsg.Cargo_Department')">
          <cargo-advance-select
            :callback-params="{key:'departmentId'}"
            :default-value="form.departmentId"
            :select-type="selectTypeNames.basic_data_Department"
            :method-params="{officeUuid:$store.getters.currentOfficeUuid}"
            callback-method-type="value"
            filterable
            style="width: 150px;"
            no="5"
            @parentCallBack="selectChangeHandler"
          />
        </el-form-item>
        <!--币种-->
        <el-form-item :label="$t('CargoMsg.Cargo_Currency')">
          <el-select v-model="form.currency" style="width: 105px;" no="6">
            <el-option
              v-for="item in usedCurrencyCollection"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <!--截至时间-->
        <el-form-item :label="$t('CargoMsg.Cargo_EndDate')">
          <el-date-picker v-model="form.overdueDate" format="yyyy-MM-dd" style="width: 120px;" no="7" />
        </el-form-item>
        <br>
        <!--逾期天数-->
        <el-form-item :label="$t('CargoMsg.Cargo_DaysOverdue')">
          <el-input-number v-model="form.startDay" :controls="false" :min="0" :precision="0" style="width: 50px;" no="8" />
        </el-form-item>
        <el-form-item label="-">
          <el-input-number v-model="form.endDay" :controls="false" :min="0" :precision="0" style="width: 50px;" no="9" />
        </el-form-item>
        <!--余额-->
        <el-form-item :label="$t('CargoMsg.Cargo_Balance')">
          <el-select v-model="form.operator" style="width: 60px;" no="10">
            <el-option
              v-for="item in operatorArr"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.balance" style="width: 80px;" no="11" />
        </el-form-item>
        <el-form-item>
          <!--显示明细科目-->
          <el-checkbox v-model="form.showBalance" :label="$t('CargoMsg.Cargo_ShowOpeningBalance')" no="12" />
          <!--含期末调汇分录-->
          <el-checkbox v-model="form.showAdjustRateEntry" :label="$t('CargoMsg.Cargo_ShowAdjustRateEntry')" no="13" />
          <!--查询-->
          <el-button class="el-margin" type="primary" style="margin-left: 20px;" no="14" @click="doSearch">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="section" style="flex: 1;padding: 0px;">
      <cargo-ag-grid
        :show-side-bar="false"
        :column-defs="columnDefs"
        :grid-options="gridOptions"
        :grid-params.sync="girdParams"
        :row-data="rowData"
        :auto-fit-content="false"
        style="height: 800px;"
        no="15"
      />
    </div>
    <div class="pagination-wrapper">
      <debit-credit-total-group :row-data="rowData" :visible="totalGroupVisible" style="float: right;margin-right: 10px" no="16" @clickCallBack="totalGroupVisible=!totalGroupVisible" />
    </div>
  </div>
</template>

<script>
import * as NumberUtils from '@/utils/NumberUtils'
import { cache } from '@/utils/cacheManager'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as accountingEntryApi from '@/api/financeManage/accountingEntry'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import DateUtils from '@/utils/dateUtils'
import DebitCreditTotalGroup from '@/views/cargo/v0/FinanceManage/AccountBook/components/DebitCreditTotalGroup'
import { exportExcel } from '@/utils/tableDataExportUtils'
import { formatNumberToThousands } from '@/utils'

export default {
  name: 'DealingsBalanceView2MultiCurrency',
  components: { cargoAdvanceSelect, DebitCreditTotalGroup },
  props: {
    accountSet: { type: Object, default: null },
    usedCurrencyCollection: { type: Array, default: null }
  },
  data() {
    return {
      totalGroupVisible: false,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          minWidth: 80,
          menuTabs: [], // 去掉每列的菜单
          sortable: false // 去掉每列的排序
        },
        suppressContextMenu: false,
        getContextMenuItems: () => {
          const self = this
          return [
            {
              name: self.$t('CargoMsg.Cargo_ExcelExport'),
              action: function() {
                self.exportExcelHandler()
              }
            }
          ]
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.itemCheckHandler(event.data)
        },
        onCellDoubleClicked: event => {
          // this.editHandler(event.data)
        }
      },
      rowData: [],
      selectTypeNames: TYPE_NAMES,
      operatorArr: [
        { name: ' ', value: -1 },
        { name: this.$t('CargoMsg.Cargo_GreaterThan'), value: 0 },
        { name: this.$t('CargoMsg.Cargo_EqualTo'), value: 1 },
        { name: this.$t('CargoMsg.Cargo_LessThan'), value: 2 }
      ],
      form: {
        accountTitle: null,
        sales: 0,
        customer: 0,
        projectNumber: '',
        departmentId: null,
        currency: '',
        overdueDate: '',
        startDay: 0,
        endDay: 30,
        operator: -1,
        balance: null,
        showBalance: true,
        showAdjustRateEntry: false
      },
      lbDbAmount: '',
      lbCreAmount: '',
      accountingEntriesForDealingsBalanceType: false,
      updateAccountingEntryPaidOffFlag: false
    }
  },
  computed: {
    // 当前会计期间
    currentFiscalPeriod() {
      return this.accountSet ? this.accountSet.currentFiscalPeriod : null
    },
    // 科目
    accountTitleCollection() {
      return this.accountSet ? this.accountSet.accountTitle : []
    },
    // 部门编码映射
    mappingDepartments() {
      return this.accountSet ? this.accountSet.mappingDepartments : []
    },
    currentAccountTitleCollection() {
      return this.accountTitleCollection.filter(title => title.currentAccount)
    },
    columnDefs() {
      const result = [
        {
          headerName: '',
          field: '',
          width: 180,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_AccountTitle'),
              field: 'ACCOUNT_TITLE_NAME',
              width: 180
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 100,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_Salesman'),
              field: 'SALES_NAME',
              width: 100
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 220,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_Customer'),
              field: 'ACCOUNT_NAME',
              width: 220
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 100,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_Department'),
              field: 'DEPARTMENT_NAME',
              width: 100
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 120,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_BusinessDocNo'),
              field: 'PROJECT_NUMBER',
              width: 120
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 120,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_BusinessDocNo2'),
              field: 'PROJECT_NUMBER2',
              width: 120
            }
          ]
        }
      ]
      if (this.accountBalanceDisplayColumnControl) {
        result.push({
          headerName: '',
          field: '',
          width: 120,
          hide: !this.accountBalanceDisplayColumnControl,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_MblNo'),
              field: 'MBL',
              width: 120
            }
          ]
        })
      }
      const lastResult = [
        {
          headerName: '',
          field: '',
          width: 100,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_DaysOverdue'),
              field: 'OVERDUEDATE',
              width: 100,
              cellRenderer: params => {
                if (params.value < 0) {
                  return '0'
                }
                return params.value
              },
              cellStyle: { textAlign: 'right' }
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 120,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_BusinessHappenDate'),
              field: 'BUSINESS_DATE',
              width: 120,
              cellRenderer: params => {
                return ColumnUtils.dateLabelFunc(params.value)
              }
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 80,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_Loan'),
              field: 'DEBIT_CREBIT',
              width: 80,
              cellStyle: { textAlign: 'center' }
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 80,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_Currency'),
              field: 'SOURCE_CURRENCY',
              width: 80,
              cellStyle: { textAlign: 'center' }
            }
          ]
        },
        {
          headerName: '\u3000\u3000\u3000\u3000\u3000\u3000\u3000' + this.$t('CargoMsg.Cargo_Balance'),
          field: '',
          width: 240,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_SourceAmount'),
              field: 'BALANCE_USD',
              width: 120,
              valueFormatter: params => {
                return formatNumberToThousands(this.numberFormat(params.value), 2)
              },
              cellStyle: { textAlign: 'right' }
            }, {
              headerName: this.$t('CargoMsg.Cargo_LocalAmount'),
              field: 'BALANCE_RMB',
              width: 120,
              valueFormatter: params => {
                return formatNumberToThousands(this.numberFormat(params.value), 2)
              },
              cellStyle: { textAlign: 'right' }
            }
          ]
        }
      ]
      result.push(...lastResult)
      return result
    },
    columnDefsRMB() {
      const result = [
        {
          headerName: this.$t('CargoMsg.Cargo_AccountTitle'),
          field: 'ACCOUNT_TITLE_NAME',
          width: 180
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Salesman'),
          field: 'SALES_NAME',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Customer'),
          field: 'ACCOUNT_NAME',
          width: 220
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Department'),
          field: 'DEPARTMENT_NAME',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessDocNo'),
          field: 'PROJECT_NUMBER',
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessDocNo2'),
          field: 'PROJECT_NUMBER2',
          width: 120
        }
      ]
      if (this.accountBalanceDisplayColumnControl) {
        result.push({
          headerName: this.$t('CargoMsg.Cargo_MblNo'),
          field: 'MBL',
          hide: !this.accountBalanceDisplayColumnControl,
          width: 120
        })
      }
      const lastResult = [
        {
          headerName: this.$t('CargoMsg.Cargo_DaysOverdue'),
          field: 'OVERDUEDATE',
          width: 100,
          cellRenderer: params => {
            if (params.value < 0) {
              return '0'
            }
            return params.value
          },
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessHappenDate'),
          field: 'BUSINESS_DATE',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Loan'),
          field: 'DEBIT_CREBIT',
          width: 80,
          cellStyle: { textAlign: 'center' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Currency'),
          field: 'SOURCE_CURRENCY',
          width: 80,
          cellStyle: { textAlign: 'center' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Balance'),
          field: 'BALANCE_RMB',
          width: 120,
          valueFormatter: params => {
            return formatNumberToThousands(this.numberFormat(params.value), 2)
          },
          cellStyle: { textAlign: 'right' }
        }
      ]
      result.push(...lastResult)
      return result
    },
    excelColumnDefs() {
      const result = [
        {
          headerName: this.$t('CargoMsg.Cargo_AccountTitle'),
          field: 'ACCOUNT_TITLE_NAME',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Salesman'),
          field: 'SALES_NAME',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Customer'),
          field: 'ACCOUNT_NAME',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Department'),
          field: 'DEPARTMENT_NAME',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessDocNo'),
          field: 'PROJECT_NUMBER',
          width: 100
        }]
      if (this.accountBalanceDisplayColumnControl) {
        result.push({
          headerName: this.$t('CargoMsg.Cargo_MblNo'),
          field: 'MBL',
          hide: !this.accountBalanceDisplayColumnControl,
          width: 100
        })
      }
      const lastResult = [
        {
          headerName: this.$t('CargoMsg.Cargo_DaysOverdue'),
          field: 'OVERDUEDATE',
          width: 100,
          cellRenderer: params => {
            if (params.value < 0) {
              return '0'
            }
            return params.value
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessHappenDate'),
          field: 'BUSINESS_DATE',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Loan'),
          field: 'DEBIT_CREBIT',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Currency'),
          field: 'SOURCE_CURRENCY',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BalanceSource'),
          field: 'BALANCE_USD',
          width: 100,
          valueFormatter: params => {
            return this.numberFormat(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_BalanceLocal'),
          field: 'BALANCE_RMB',
          width: 100,
          valueFormatter: params => {
            return this.numberFormat(params.value)
          }
        }
      ]
      result.push(...lastResult)
      return result
    }
  },
  watch: {
    accountSet(newVal) {
      if (newVal) {
        this.form.currency = this.usedCurrencyCollection[0]
      }
    }
  },
  created() {
    this.form.overdueDate = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
    this.form.currency = this.usedCurrencyCollection[0]
    this.accountingEntriesForDealingsBalanceType = Number(cache.config.get('AccountingEntriesForDealingsBalanceType')) === 1
    this.accountBalanceDisplayColumnControl = Number(cache.config.get('AccountBalanceDisplayColumnControl')) === 1
    this.updateAccountingEntryPaidOffFlag = Number(cache.config.get('updateAccountingEntryPaidOffFlag')) === 1
  },
  methods: {
    numberFormat(value) {
      if (value) {
        return NumberUtils.formatRoundNumber(value, 2)
      }
      return ''
    },
    accountTitleLabelFun(accountTitle) {
      return accountTitle ? accountTitle.accountTitle + '_' + accountTitle.accountTitleName : ''
    },
    selectChangeHandler(params) {
      this.form[params.key] = params.value
    },
    doSearch() {
      const obj = {}
      obj.accountSet = this.accountSet.uuid
      obj.dealingsCustomer = this.accountSet.dealingsCustomer
      obj.year = this.currentFiscalPeriod.year
      obj.documentMonthEnd = this.currentFiscalPeriod.month
      if (this.form.accountTitle) {
        const accountTitle = this.currentAccountTitleCollection.find(title => title.uuid === this.form.accountTitle)
        obj.accountTitle = accountTitle ? accountTitle.accountTitle : ''
      }
      if (this.form.sales) {
        obj.sales = this.form.sales
      }
      if (this.form.customer) {
        obj.customer = this.form.customer
      }
      if (this.form.projectNumber) {
        obj.projectNumber = this.form.projectNumber
      }
      if (this.form.departmentId) {
        obj.department = this.form.departmentId
      }
      if (this.form.currency && this.form.currency !== this.$t('CargoMsg.Cargo_ConsolidatedLocalCurrency')) {
        obj.currency = this.form.currency
      }
      obj.overdueDate = this.form.overdueDate
      obj.startDay = this.form.startDay || 0
      obj.endDay = this.form.endDay || 0
      obj.operator = this.form.operator
      obj.balance = this.form.balance ? Number(this.form.balance) : 0
      // 显示期初余额
      if (this.form.showBalance) {
        obj.showBalance = this.form.showBalance
      }
      // 显示期末调汇分录
      obj.showAdjustRateEntry = this.form.showAdjustRateEntry
      // 是否更新往来科目客商项目编号币种已核销（0=默认关闭，1=开启）
      obj.updateAccountingEntryPaidOffFlag = this.updateAccountingEntryPaidOffFlag
      // const AccountingEntriesForDealingsBalanceType = Number(cache.config.get('AccountingEntriesForDealingsBalanceType')) === 1
      this.setColumnVisible()
      const loading = getLoading()
      if (this.accountingEntriesForDealingsBalanceType) {
        obj.branchId = this.$store.getters.currentOfficeId
        accountingEntryApi.getAccountingEntriesForDealingsBalance2NewByMultiCurrency({ conditionMap: obj }).then(resp => {
          this.standardCurrencyHandler(resp)
        }).finally(() => loading.close())
      } else {
        accountingEntryApi.getAccountingEntriesForDealingsBalance2ByMultiCurrency({ conditionMap: obj }).then(resp => {
          this.standardCurrencyHandler(resp)
        }).finally(() => loading.close())
      }
    },
    standardCurrencyHandler(resp) {
      const result = resp.data
      if (result) {
        let debitAmount = 0.0
        let crebitAmount = 0.0
        for (const item of result) {
          if (item.DEBIT_RMB) {
            debitAmount += NumberUtils.parseNumber(item.DEBIT_RMB, 0)
          }
          if (item.CREDIT_RMB) {
            crebitAmount += NumberUtils.parseNumber(item.CREDIT_RMB, 0)
          }
        }
        this.lbDbAmount = NumberUtils.formatNumber(debitAmount, 2)
        this.lbCreAmount = NumberUtils.formatNumber(crebitAmount, 2)
        this.rowData = result
      }
    },
    setColumnVisible() {
      this.gridOptions.api.setColumnDefs([])
      if (this.form.currency !== this.accountSet.localCurrency) {
        this.gridOptions.api.setColumnDefs(this.columnDefs)
      } else {
        this.gridOptions.api.setColumnDefs(this.columnDefsRMB)
      }
    },
    exportExcelHandler() {
      const columnDefs = []
      this.excelColumnDefs.forEach(column => columnDefs.push({ colDef: column }))
      exportExcel(this.$t('FinanceManage.BalanceSheetWithContacts'), this.rowData, columnDefs, true, null, true)
    },
    beforeLeaveHandler() {
      this.totalGroupVisible = false
    }
  }
}
</script>

<style scoped>
  .el-margin{
    margin: 0 0 5px 5px;
  }
</style>
